export default __webpack_public_path__ + "static/media/Autorisierter_JURA_Haendler.256da4d3.jpg";